import { useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import DeletionSection from '../../Common/DeletionBanner/DeletionSection'
import SwitchConfirmDialog from '../../Common/SwitchConfirmDialog/SwitchConfirmDialog'
import { useAppDispatch } from '../../../store'
import { displaySnackbar } from '../../../actions/main'
import { PlannedConsultationDeletionProps } from './_props'
import { defaultPalette } from '../../../theme/idsTheme'
import { useDeleteIdsHealthcareservicesHcsIdConsultationsConsultationId } from '@toktokdoctech/tokapi-client'
import { useNavigate } from 'react-router-dom'
import useCurrentHcs from '../../../hooks/useCurrentHcs'

const PlannedConsultationDeletion = ({ consultationId }: PlannedConsultationDeletionProps) => {
    const dispatch = useAppDispatch()
    const currentHcs = useCurrentHcs()
    const navigate = useNavigate()

    const [isDeletionRequested, setIsDeletionRequested] = useState(false)
    const [isDeletionLoading, setIsDeletionLoading] = useState(false)

    const { mutate } = useDeleteIdsHealthcareservicesHcsIdConsultationsConsultationId({
        mutation: {
            onMutate: () => {
                setIsDeletionLoading(true)
            },
            onSuccess: () => {
                dispatch(
                    displaySnackbar(
                        'success',
                        'La téléconsultation a bien été supprimée',
                        undefined,
                        `[PlannedConsultationDeletion] suppression téléconsultation préparée ${consultationId ?? ''}`,
                    ),
                )
                navigate('/planned-consultations')
            },
            onError: (err: unknown) => {
                const error = err instanceof Error ? err.message : String(err)
                console.error(`[PlannedConsultationDeletion] error catched | message : ${error}`)
                dispatch(
                    displaySnackbar(
                        'error',
                        'Une erreur est survenue pendant la suppression de la téléconsultation',
                        undefined,
                        `[PlannedConsultationDeletion] suppression téléconsultation préparée ${consultationId ?? ''}`,
                    ),
                )
            },
            onSettled: () => {
                setIsDeletionLoading(false)
            },
        },
    })

    return (
        <>
            <DeletionSection
                bannerLabel="Supprimer la téléconsultation"
                bannerSubLabel="Après confirmation, la suppression sera définitive"
                onConfirm={() => setIsDeletionRequested(true)}
            />
            {isDeletionRequested && (
                <SwitchConfirmDialog
                    title="Êtes-vous sûr de vouloir supprimer la téléconsultation ?"
                    bannerTitle="Avant de supprimer la téléconsultation"
                    bannerText="Contactez le secrétariat médical du médecin pour l’informer de l’annulation, puis confirmez la suppression"
                    switchText="Suppression validée par le secrétariat"
                    submitText="Supprimer"
                    isLoading={isDeletionLoading}
                    onApprove={() => mutate({ consultationId, hcsId: currentHcs.id })}
                    onCancel={() => setIsDeletionRequested(false)}
                    saveStartIcon={<DeleteIcon />}
                    submitBackgroundColor={defaultPalette.red.main}
                />
            )}
        </>
    )
}

export default PlannedConsultationDeletion
